import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import './header.api.scss';
import LogoWide from "./images/logowide";

interface HeaderEcomProps {
  location: Location;
  siteTitle: string;
}

const HeaderApi: React.FC<HeaderEcomProps> = ({ siteTitle, location }) => (
  <header id="api">
    <div>
      <Link to="/">
        <div className="logos">
          <LogoWide format={'icon'} />
          <LogoWide format={'text'} />
        </div>
      </Link>
    </div>
    <div className="rightLinks">
      <Link to="/api/referencia" activeClassName="active">
        Referencia API
        </Link>
      <Link to="/api/catalogo" activeClassName="active">
        Catálogo SAT
        </Link>
      <Link to="/api/guia" activeClassName="active">
        Guía CSD
        </Link>
    </div>
  </header>
)


export default HeaderApi
